// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Menu } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconMenu(props: any) {
    return <IconBase icon={Menu} {...props} />
  }

  export default IconMenu
  